export const manifest = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    manufacturerCode: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    modelDesc: { en: 'Description', ko: '설명', fr: '' },
    version: { en: 'Version', ko: '버전', fr: '' },
  },
  info: {
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    manifest: { en: 'Manifest', ko: '매니페스트', fr: '' },
    modelDesc: { en: 'Model description', ko: '모델 설명', fr: '' },
    version: { en: 'Version', ko: '버전', fr: '' },
  },
  select: {
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
  },
  placeholder: {
    model: { en: 'Search by model', ko: '모델을 입력하세요.' },
  },
};
